import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { LayoutStore, LayoutStoreType } from '../../../../core/store/layout.store';

@Component({
    selector: 'juyo-popup-base',
    styleUrl: 'popup-base.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="popup-backdrop" (click)="requestClose()"></div>
        <div class="popup-card" [style.max-width]="maxWidth()">
            @if (showHeader()) {
                <div class="popup-header">
                    <ng-content select="[slot=header]"></ng-content>
                    <button class="popup-close" type="button" aria-label="Close" (click)="requestClose()">
                        <span class="material-symbols-outlined"> close </span>
                    </button>
                </div>
            } @else {
                <button class="popup-close popup-close--no-header" type="button" aria-label="Close" (click)="requestClose()">
                    <span class="material-symbols-outlined"> close </span>
                </button>
            }
            <div class="popup-body">
                <ng-content select="[slot=body]"></ng-content>
            </div>
            @if (showFooter()) {
                <div class="popup-footer">
                    <ng-content select="[slot=footer]"></ng-content>
                </div>
            }
        </div>
    `,
})
export class PopupBaseComponent {
    public popupId = input.required<string>();
    public showHeader = input<boolean>(true);
    public showFooter = input<boolean>(true);
    public maxWidth = input<string>('600px');
    public autoClose = input<boolean>(true);

    public closeRequest = output<void>();

    private layoutStore: LayoutStoreType = inject(LayoutStore);

    protected requestClose(): void {
        this.closeRequest.emit();
        if (this.autoClose()) {
            this.onClose();
        }
    }

    protected onClose(): void {
        this.layoutStore.closePopup(this.popupId());
    }
}
